export const HELPTEXT_DRAWER_ID = "HelptextDrawerId";
export const HELPTEXT_CLOSE_ID = "HelptextCloseId";
export const HELPTEXT_TITLE_ID = "HelptextTitleId";
export const HELPTEXT_SUBTITLE_ID = "HelptextSubtitleId";
export const HELPTEXT_BODY_ID = "HelptextBodyId";
